<template>
	<Nav v-if="gameStatus === 0" />
	<div class="viewWrapper">
		<router-view ></router-view>
	</div>
</template>
 
<script setup lang="ts">
import Nav from "@/components/Nav/Nav.vue"
import { gameStatus } from "@/services/general-service";
 
</script>
 
<style lang="scss">
body{
	padding: 0;
	margin: 0;
	color: white;
	background: rgb(21,21,21);
}
.viewWrapper{
	display: grid;
	place-content: center;
}
</style>
